import { defineMessages } from "react-intl";
export default defineMessages({
    about: {
        id: "settings.about",
        defaultMessage: "About",
    },
    aboutDescription: {
        id: "settings.aboutDescription",
        defaultMessage: "License agreement, privacy policy",
    },
    account: {
        id: "settings.account",
        defaultMessage: "Profile & Security",
    },
    accountDescription: {
        id: "settings.accountDescription",
        defaultMessage: "Name, password, delete account",
    },
    accountIntro: {
        id: "settings.accountIntro",
        defaultMessage: "Data concerns your account:",
    },
    accountSection: {
        id: "settings.accountSection",
        defaultMessage: "Account",
    },
    appVersion: {
        id: "settings.appVersion",
        defaultMessage: "SmartMixin v{version}",
    },
    appearance: {
        id: "settings.appearance",
        defaultMessage: "Appearance",
    },
    appearanceDescription: {
        id: "settings.appearanceDescription",
        defaultMessage: "Theme and display options",
    },
    arabic: {
        id: "settings.arabic",
        defaultMessage: "Arabic",
    },
    availableServices: {
        id: "settings.availableServices",
        defaultMessage: "Available",
    },
    bulgarian: {
        id: "settings.bulgarian",
        defaultMessage: "Bulgarian",
    },
    cannotDisconnectLastAccount: {
        id: "settings.cannotDisconnectLastAccount",
        defaultMessage: "Cannot disconnect your only login method. Please add another login method first.",
    },
    catalan: {
        id: "settings.catalan",
        defaultMessage: "Catalan",
    },
    changeEmail: {
        id: "settings.changeEmail",
        defaultMessage: "Change email",
    },
    changePassword: {
        id: "settings.changePassword",
        defaultMessage: "Change password",
    },
    chartGestures: {
        id: "settings.chartGestures",
        defaultMessage: "Gestures on charts",
    },
    chartGesturesDescription: {
        id: "settings.chartGesturesDescription",
        defaultMessage: "Swiping on charts changes the time period, pinching charts changes time scale",
    },
    connect: {
        id: "settings.connect",
        defaultMessage: "Connect",
    },
    connected: {
        id: "settings.connected",
        defaultMessage: "Connected",
    },
    connectedAccounts: {
        id: "settings.connectedAccounts",
        defaultMessage: "Connected Accounts",
    },
    connectedAccountsDescription: {
        id: "settings.connectedAccountsDescription",
        defaultMessage: "Apple, Google, Facebook",
    },
    connectedServices: {
        id: "settings.connectedServices",
        defaultMessage: "Connected",
    },
    connectedSince: {
        id: "settings.connectedSince",
        defaultMessage: "Connected since {date}",
    },
    connectionSuccess: {
        id: "settings.connectionSuccess",
        defaultMessage: "{provider} account connected successfully",
    },
    contactUs: {
        id: "settings.contactUs",
        defaultMessage: "Contact Us",
    },
    contactUsDescription: {
        id: "settings.contactUsDescription",
        defaultMessage: "Get help or send feedback",
    },
    croatian: {
        id: "settings.croatian",
        defaultMessage: "Croatian",
    },
    currentPassword: {
        id: "settings.currentPassword",
        defaultMessage: "Current password",
    },
    czech: {
        id: "settings.czech",
        defaultMessage: "Czech",
    },
    danish: {
        id: "settings.danish",
        defaultMessage: "Danish",
    },
    dark: {
        id: "settings.dark",
        defaultMessage: "Dark theme",
    },
    dataDisplay: {
        id: "settings.dataDisplay",
        defaultMessage: "Data display",
    },
    dateAndTime: {
        id: "settings.dateAndTime",
        defaultMessage: "Date and time",
    },
    disconnect: {
        id: "settings.disconnect",
        defaultMessage: "Disconnect",
    },
    disconnectConfirmation: {
        id: "settings.disconnectConfirmation",
        defaultMessage: "Are you sure you want to disconnect your {provider} account?",
    },
    disconnectionSuccess: {
        id: "settings.disconnectionSuccess",
        defaultMessage: "{provider} account disconnected successfully",
    },
    donateTitle: {
        id: "settings.donateTitle",
        defaultMessage: "Support SmartMixin",
    },
    donateDescription: {
        id: "settings.donateDescription",
        defaultMessage: "SmartMixin is built by a small team. If you find it useful, you can support its development with a one-time donation of any amount. It's a gift — it doesn't change your plan or unlock any features.",
    },
    donateButton: {
        id: "settings.donateButton",
        defaultMessage: "Make a donation",
    },
    donateSuccessTitle: {
        id: "settings.donateSuccessTitle",
        defaultMessage: "Thank you for your support!",
    },
    donateSuccessBody: {
        id: "settings.donateSuccessBody",
        defaultMessage: "Your donation helps keep SmartMixin running and improving. We truly appreciate it.",
    },
    dutch: {
        id: "settings.dutch",
        defaultMessage: "Dutch",
    },
    emailChange: {
        id: "settings.emailChange",
        defaultMessage: "Change email address",
    },
    emailChangeConfirmation: {
        id: "settings.emailChangeConfirmation",
        defaultMessage: "Email Change Confirmation",
    },
    emailChangeFailure: {
        id: "settings.emailChangeFailure",
        defaultMessage: "The email change link is invalid or has expired.",
    },
    emailChangeSuccess: {
        id: "settings.emailChangeSuccess",
        defaultMessage: "Your email has been successfully changed to {newEmail}.",
    },
    emailChangeVerificationSent: {
        id: "settings.emailChangeVerificationSent",
        defaultMessage: "A verification email has been sent to your new email address. Please check your inbox and click the link to confirm the change.",
    },
    english: {
        id: "settings.english",
        defaultMessage: "English",
    },
    forecastModelOrderEmpty: {
        id: "settings.forecastModelOrderEmpty",
        defaultMessage: "No order saved — we use GFS by default.",
    },
    forecastModelOrderFreeHint: {
        id: "settings.forecastModelOrderFreeHint",
        defaultMessage: "Premium models require a SmartMixin Premium subscription.",
    },
    forecastModelOrderHelp: {
        id: "settings.forecastModelOrderHelp",
        defaultMessage: "We pick the first model in your list that covers each station.",
    },
    forecastModelOrderReset: {
        id: "settings.forecastModelOrderReset",
        defaultMessage: "Reset to default",
    },
    forecastModelOrderTitle: {
        id: "settings.forecastModelOrderTitle",
        defaultMessage: "Default forecast model",
    },
    forecastModels: {
        id: "settings.forecastModels",
        defaultMessage: "Forecast models",
    },
    forecastModelsDescription: {
        id: "settings.forecastModelsDescription",
        defaultMessage: "Reorder by preference",
    },
    french: {
        id: "settings.french",
        defaultMessage: "French",
    },
    german: {
        id: "settings.german",
        defaultMessage: "German",
    },
    gestures: {
        id: "settings.gestures",
        defaultMessage: "Gestures",
    },
    greek: {
        id: "settings.greek",
        defaultMessage: "Greek",
    },
    helpCenter: {
        id: "settings.helpCenter",
        defaultMessage: "Help Center",
    },
    helpCenterDescription: {
        id: "settings.helpCenterDescription",
        defaultMessage: "FAQs and guides",
    },
    hungarian: {
        id: "settings.hungarian",
        defaultMessage: "Hungarian",
    },
    integrationsSection: {
        id: "settings.integrationsSection",
        defaultMessage: "Integrations",
    },
    italian: {
        id: "settings.italian",
        defaultMessage: "Italian",
    },
    japanese: {
        id: "settings.japanese",
        defaultMessage: "Japanese",
    },
    korean: {
        id: "settings.korean",
        defaultMessage: "Korean",
    },
    language: {
        id: "settings.language",
        defaultMessage: "Language",
    },
    languageDescription: {
        id: "settings.languageDescription",
        defaultMessage: "Preferred language",
    },
    light: {
        id: "settings.light",
        defaultMessage: "Light theme",
    },
    newEmailAddress: {
        id: "settings.newEmailAddress",
        defaultMessage: "New email address",
    },
    newPassword: {
        id: "settings.newPassword",
        defaultMessage: "New password",
    },
    newPasswordAgain: {
        id: "settings.newPasswordAgain",
        defaultMessage: "New password again",
    },
    norwegian: {
        id: "settings.norwegian",
        defaultMessage: "Norwegian",
    },
    notConnected: {
        id: "settings.notConnected",
        defaultMessage: "Not connected",
    },
    notificationsSection: {
        id: "settings.notificationsSection",
        defaultMessage: "Notifications",
    },
    oldPassword: {
        id: "settings.oldPassword",
        defaultMessage: "Old password",
    },
    ongoingNotificationEnabled: {
        id: "settings.ongoingNotificationEnabled",
        defaultMessage: "Enable ongoing notification",
    },
    ongoingNotificationMetrics: {
        id: "settings.ongoingNotificationMetrics",
        defaultMessage: "Displayed metrics",
    },
    ongoingNotificationMetricsHint: {
        id: "settings.ongoingNotificationMetricsHint",
        defaultMessage: "Drag to reorder selected metrics",
    },
    ongoingNotificationPermissionRequired: {
        id: "settings.ongoingNotificationPermissionRequired",
        defaultMessage: "Notification permission is required",
    },
    ongoingNotificationStation: {
        id: "settings.ongoingNotificationStation",
        defaultMessage: "Weather station",
    },
    passwordChange: {
        id: "settings.passwordChange",
        defaultMessage: "Password change",
    },
    polish: {
        id: "settings.polish",
        defaultMessage: "Polish",
    },
    portuguese: {
        id: "settings.portuguese",
        defaultMessage: "Portuguese",
    },
    preferencesSection: {
        id: "settings.preferencesSection",
        defaultMessage: "Preferences",
    },
    premium: {
        id: "settings.premium",
        defaultMessage: "SmartMixin Premium",
    },
    premiumActive: {
        id: "settings.premiumActive",
        defaultMessage: "Active",
    },
    premiumCurrentPlan: {
        id: "settings.premiumCurrentPlan",
        defaultMessage: "Current Plan",
    },
    premiumDescription: {
        id: "settings.premiumDescription",
        defaultMessage: "Manage your subscription",
    },
    premiumDownloadApp: {
        id: "settings.premiumDownloadApp",
        defaultMessage: "Download the app to subscribe:",
    },
    premiumExpiresOn: {
        id: "settings.premiumExpiresOn",
        defaultMessage: "Renews on {date}",
    },
    premiumFreePlan: {
        id: "settings.premiumFreePlan",
        defaultMessage: "Free",
    },
    premiumInactive: {
        id: "settings.premiumInactive",
        defaultMessage: "Not subscribed",
    },
    premiumPremiumPlan: {
        id: "settings.premiumPremiumPlan",
        defaultMessage: "Premium",
    },
    premiumSubscribedOn: {
        id: "settings.premiumSubscribedOn",
        defaultMessage: "Subscribed on {platform}",
    },
    premiumWebappNotice: {
        id: "settings.premiumWebappNotice",
        defaultMessage: "Subscriptions can only be purchased through the SmartMixin mobile app on iOS or Android.",
    },
    premiumSubscribeMonthly: {
        id: "settings.premiumSubscribeMonthly",
        defaultMessage: "Monthly — 1.99 €/month",
    },
    premiumSubscribeAnnual: {
        id: "settings.premiumSubscribeAnnual",
        defaultMessage: "Annual — 9.99 €/year",
    },
    premiumAnnualTrialInfo: {
        id: "settings.premiumAnnualTrialInfo",
        defaultMessage: "Start with a {days}-day free trial",
    },
    premiumAnnualThenPrice: {
        id: "settings.premiumAnnualThenPrice",
        defaultMessage: "Then 9.99 €/year",
    },
    premiumSubscribeOnWeb: {
        id: "settings.premiumSubscribeOnWeb",
        defaultMessage: "Subscribe now to unlock all premium features.",
    },
    premiumManageWebSubscription: {
        id: "settings.premiumManageWebSubscription",
        defaultMessage: "Manage your subscription, update payment method, or cancel.",
    },
    premiumSubscriptionSuccess: {
        id: "settings.premiumSubscriptionSuccess",
        defaultMessage: "Your subscription has been activated! Enjoy all premium features.",
    },
    premiumSubscriptionSuccessTitle: {
        id: "settings.premiumSubscriptionSuccessTitle",
        defaultMessage: "Welcome to Premium!",
    },
    privacyPolicy: {
        id: "settings.privacyPolicy",
        defaultMessage: "Privacy policy",
    },
    profile: {
        id: "settings.profile",
        defaultMessage: "Profile",
    },
    russian: {
        id: "settings.russian",
        defaultMessage: "Russian",
    },
    serbian: {
        id: "settings.serbian",
        defaultMessage: "Serbian",
    },
    settings: {
        id: "settings.settings",
        defaultMessage: "Settings",
    },
    slovak: {
        id: "settings.slovak",
        defaultMessage: "Slovak",
    },
    smallDecimals: {
        id: "settings.smallDecimals",
        defaultMessage: "Small decimals",
    },
    smallDecimalsDescription: {
        id: "settings.smallDecimalsDescription",
        defaultMessage: "Display decimal digits in a smaller size",
    },
    windDirectionConvention: {
        id: "settings.windDirectionConvention",
        defaultMessage: "Wind direction arrow",
    },
    windDirectionConventionDescription: {
        id: "settings.windDirectionConventionDescription",
        defaultMessage: "Choose how wind direction arrows are displayed",
    },
    windDirectionOceanographic: {
        id: "settings.windDirectionOceanographic",
        defaultMessage: "Flow direction",
    },
    windDirectionOceanographicDescription: {
        id: "settings.windDirectionOceanographicDescription",
        defaultMessage: "Arrow points where the wind blows to (oceanographic convention)",
    },
    windDirectionMeteorological: {
        id: "settings.windDirectionMeteorological",
        defaultMessage: "Origin direction",
    },
    windDirectionMeteorologicalDescription: {
        id: "settings.windDirectionMeteorologicalDescription",
        defaultMessage: "Arrow points where the wind comes from (meteorological convention)",
    },
    socialConnectionsIntro: {
        id: "settings.socialConnectionsIntro",
        defaultMessage: "Link your social accounts to enable quick sign-in. You can connect or disconnect accounts at any time.",
    },
    spanish: {
        id: "settings.spanish",
        defaultMessage: "Spanish",
    },
    statusBarWidget: {
        id: "settings.statusBarWidget",
        defaultMessage: "Status Bar Widget",
    },
    statusBarWidgetDescription: {
        id: "settings.statusBarWidgetDescription",
        defaultMessage: "Always-visible weather data",
    },
    subscriptionSection: {
        id: "settings.subscriptionSection",
        defaultMessage: "Subscription",
    },
    supportSection: {
        id: "settings.supportSection",
        defaultMessage: "Support",
    },
    swedish: {
        id: "settings.swedish",
        defaultMessage: "Swedish",
    },
    systemTheme: {
        id: "settings.systemTheme",
        defaultMessage: "System theme",
    },
    termsOfService: {
        id: "settings.termsOfService",
        defaultMessage: "Terms of service",
    },
    turkish: {
        id: "settings.turkish",
        defaultMessage: "Turkish",
    },
    ukrainian: {
        id: "settings.ukrainian",
        defaultMessage: "Ukrainian",
    },
    units: {
        id: "settings.units",
        defaultMessage: "Units",
    },
    unitsDescription: {
        id: "settings.unitsDescription",
        defaultMessage: "Measurement units displayed within the application",
    },
    update: {
        id: "settings.update",
        defaultMessage: "Update",
    },
    updateYourProfile: {
        id: "settings.updateYourProfile",
        defaultMessage: "Update your profile",
    },
    weatherServices: {
        id: "settings.weatherServices",
        defaultMessage: "Weather Services",
    },
    weatherServicesConnected: {
        id: "settings.weatherServicesConnected",
        defaultMessage: "{count, plural, =0 {No services connected} one {# service connected} other {# services connected}}",
    },
    weatherServicesDescription: {
        id: "settings.weatherServicesDescription",
        defaultMessage: "Connect Netatmo, Davis, Weatherflow, and more",
    },
});
